const cacem = {
  FORMS: [
    {
      type: "cacem-form-contact",
      name: "CacemContactForm",
      message: {
        open: "Formulario Contacto",
        send: "Envío Formulario De Contacto",
      },
    },
  ],
  CSS: {
    id: "617afe5a84d999329065f5b7",
    name: "cacem",
    avatar: {
      name: "CACEM",
      header: "https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/C297pYJ6Hko01650426207804.png",
      new: "https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/dEQfhIINqXCw1650426193812.png",
      open: "https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/VwNdpOe9KHgx1650426178555.png",
      close: "https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/C297pYJ6Hko01650426207804.png",
    },
    style: {
      score: {
        inactiveColor: "#fff",
        activeColor: "#00b2bd",
        borderColor: "#00b2bd",
      },
    },
  },
};

export default cacem;
